import { Slider, keyframes, lighten, styled } from '@mui/material';
import { BaseCard, BaseCardLabel, } from 'console/shared/styles/mixins/base-card';
import { useAnimationPermissions, useDesignPackage } from 'console/shared/hooks/helpers';
import { useMemo } from 'react';
export const SensorCard = styled(BaseCard, {
    shouldForwardProp: (prop) => prop !== 'alarm' &&
        prop !== 'active_green' &&
        prop !== 'no_connection' &&
        prop !== 'is_worker',
})(({ alarm, active_green, theme, no_connection, is_worker }) => {
    const allow_design_package = useDesignPackage();
    const animation_permissions = useAnimationPermissions();
    const anim_alarm = useMemo(() => allow_design_package && animation_permissions.sensor_alarm, [allow_design_package, animation_permissions.sensor_alarm]);
    const colorAlarm_Is_working = is_worker
        ? theme.palette.warning
        : theme.palette.error;
    const animation_is_wowrker = keyframes `
    20%{
        background-color: ${theme.palette.warning.main}
      }
    40% {
        background-color: ${lighten(theme.palette.warning.main, 0.3)}
      }
    60%{
        background-color: ${theme.palette.warning.main}
      }
    80% {
        background-color: ${lighten(theme.palette.warning.main, 0.3)}
      }
`;
    return {
        display: 'flex',
        fontSize: '0.9em',
        columnGap: 8,
        backgroundColor: no_connection && !alarm
            ? theme.palette.grey.A400
            : alarm
                ? active_green
                    ? theme.palette.success.main
                    : colorAlarm_Is_working.main
                : theme.palette.background.paper,
        color: alarm ? colorAlarm_Is_working.contrastText : theme.palette.text.primary,
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
        ...(anim_alarm &&
            alarm &&
            is_worker !== true && {
            animation: '1.5s infinite alternate pulse',
            '@keyframes pulse': {
                '20%': {
                    backgroundColor: theme.palette.error.main,
                },
                '40%': {
                    backgroundColor: lighten(theme.palette.error.main, 0.3),
                },
                '60%': {
                    backgroundColor: theme.palette.error.main,
                },
                '80%': {
                    backgroundColor: lighten(theme.palette.error.main, 0.3),
                },
            },
        }),
        ...(anim_alarm &&
            alarm &&
            is_worker === true && {
            animation: `1.5s infinite alternate  ${animation_is_wowrker}`,
        }),
    };
});
export const SensorLimitsView = styled(Slider, {
    shouldForwardProp: (prop) => prop !== 'alarm' && prop !== 'no_connection',
})(({ no_connection, alarm, theme }) => ({
    '& .MuiSlider-thumb': {
        display: no_connection ? 'none' : 'flex',
        width: 8,
        height: 2,
        borderRadius: 12,
        left: 26,
    },
    '& .MuiSlider-markLabel': {
        fontSize: '0.5em',
        left: '-4px',
        '&[data-index="0"]': {
            bottom: '10% !important',
        },
        '&[data-index="1"]': {
            bottom: '90% !important',
        },
        color: alarm ? theme.palette.error.contrastText : theme.palette.text.secondary,
    },
    width: 3.5,
    margin: '0 10px',
    padding: '0 12px !important',
    boxSizing: 'border-box',
    pointerEvents: 'none',
    '& .MuiSlider-track': {
        width: 5,
    },
    '& .MuiSlider-rail, .MuiSlider-track': {
        margin: '0 14px',
    },
    '& input[type="range"]': {
        WebkitAppearance: 'slider-vertical',
    },
    '& .MuiSlider-markActive': {
        display: 'none',
    },
    '& .MuiSlider-mark': {
        display: 'none',
    },
}));
export const SensorCardTitle = styled(BaseCardLabel)({});
